export const capitalize = (str, separator = ' ', split = true) => {
  if (!str) return "";
  let lower = str.toLowerCase();
  if (!split) return lower[0]?.toUpperCase() + lower.slice(1)
  return lower
    .split(separator)
    .map(word => word[0]?.toUpperCase() + word.slice(1))
    .join(separator);
}